module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-focus-ripple-wrapper"
  }, [_c('div', {
    ref: "innerCircle",
    staticClass: "mu-focus-ripple",
    style: (_vm.style)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ff9e02","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/internal/focusRipple.vue
// module id = 3031
// module chunks = 1